import React, { useEffect, useState } from 'react';
import './filter_sort.scss';
import sortIcon from '../../../../src/assets/images/sort_icon.svg';
import filterIcon from '../../../../src/assets/images/filter_icon.svg';
import { Checkbox, Button } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { getAllAds } from '../../../slices/ads/thunk';
import Log from '../../../Services/Log';
import closeIcon from '../../../../src/assets/images/close_icon.svg'
import InfiniteScroll from 'react-infinite-scroll-component';
import { ShimmerSimpleGallery } from "react-shimmer-effects";
import dropdownArrow from '../../../assets/images/dropdown_arrow_dark.svg'


const FilterSort = ({ featureStatus, filterCatch, filterDropdownStatus }) => {
    const dispatch = useDispatch();
    const [parentDropdownVisible, setParentDropdownVisible] = useState({
        parent: false,
        child: false,
    });
    const [sortDropdownVisible, setSortDropdownVisible] = useState({
        parent: false,
        child: false,
    })
    const [selectedValueFilter, setSelectedValueFilter] = useState({
        key: '',
        value: '',
    });
    const [selectedValueSort, setSelectedValueSort] = useState({
        key: '',
        value: '',
    });
    const [active, setActive] = useState(false);
    const [statusData, setStatusData] = useState([]);
    const [filterOption, setFilterOption] = useState();
    const [filterDropdownVisible, setFilterDropdownVisible] = useState(false)
    const ads = useSelector((state) => {
        return state.LiveAds
    })
    const [filterSelected, setFilterSelected] = useState('All Ads');
    const [adsData, setAdsData] = useState(ads?.ads);
    const [loading, setLoading] = useState(ads?.loading)
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const limit = 6;
    const handleChangeFilter = (key, filterType) => {
        filterCatch(filterType, key)
    };
    const statusList = {
        all: { filterType: 'all', value: 'All Ads', key: 'all' },
        adminActive: { filterType: 'status', value: 'active', key: 'active' },
        TransactionPending: { filterType: 'transaction_status', value: 'Draft', key: 'pending' },
        TransactionFailed: { filterType: 'transaction_status', value: 'Pending', key: 'failed' },
        adminPending: { filterType: 'status', value: 'In Review', key: 'pending' },
        InactiveAd: { filterType: 'status', value: 'Inactive', key: 'inactive' },
        adminRejected: { filterType: 'status', value: 'rejected', key: 'rejected' },

        // TransactionCompleted: { filterType: 'transaction_status', value: 'Transaction Completed' , key: 'completed'}
    };

    useEffect(() => {
        setFilterDropdownVisible(false)
    }, [filterDropdownStatus])

    return (
        <div className="filter-sort-container">
            <InfiniteScroll
                dataLength={adsData.length}
                hasMore={hasMore}
            // loader={
            //     loading && (
            //         <ShimmerSimpleGallery card item={2} imageHeight={240} caption className="basic_shimmer_holder" />

            //         // <div className="spinner center" key={0}>
            //         //     <Spin />
            //         // </div>
            //     )
            // }
            // endMessage={<p className='no_more_text'>No more items to load</p>}

            >
                <ul className="parent_listing">
                    <li>
                        <div
                            className="filter_sort_cnt md"
                            onClick={() => {
                                setSelectedValueFilter({
                                    key: '',
                                    value: '',
                                });
                                setParentDropdownVisible((prev) => ({
                                    ...prev,
                                    parent: !prev.parent,
                                    child: false,
                                }));
                                setActive(true)
                                setFilterDropdownVisible((prev) => !prev)
                            }}
                        >
                            <Button type='dashed'>
                                {filterSelected} <span className='icon dropdown_arrow'><img src={dropdownArrow} alt="" /></span>
                            </Button>
                        </div>


                        {<div className="filter_sort_dropdown">
                            <div className={`dropdown added_closeBtn outer ${filterDropdownVisible && 'active'}`}>
                                <ul style={{ paddingLeft: '0' }} >
                                    {Object.entries(statusList).map(([key, status]) => (
                                        <li key={status.key} className={`${filterSelected === status.value ? 'active' : ''} sm`}>
                                            <Checkbox
                                                className='md'
                                                id={status.key}
                                                value={status.key}
                                                checked={selectedValueFilter.value === status.key}
                                                onChange={() => {
                                                    handleChangeFilter(status.key, status.filterType);
                                                    setFilterDropdownVisible(false)
                                                    setFilterSelected(status.value)
                                                }}
                                            >
                                                {`${status.value}`}
                                            </Checkbox>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>}
                    </li>
                </ul>
                {/* {
                    filterSelected && (
                        <span className={`${filterSelected === 'all' ? 'all' : ''} filter_selected md`}>
                            <p>{filterSelected}</p>
                            <span className="close" onClick={() => {
                                handleChangeFilter('all', 'all');
                                setFilterDropdownVisible(false)
                                setFilterSelected('all')
                            }}></span>
                        </span>
                    )
                } */}



            </InfiniteScroll>

        </div>
    );
};

export default FilterSort;
